document.addEventListener('DOMContentLoaded', function () {
const trackOrderButtons = document.querySelectorAll('.track-order-button');

let activeTrackOrderButton = null;

trackOrderButtons.forEach(button => {
    button.addEventListener('click', async function (event) {
    const submitButton = this;
    const resultContainer = submitButton.closest('.row').querySelector('.order-tracking-info');
    const orderTrackingInfo = submitButton.closest('.row').nextElementSibling;
    orderTrackingInfo.innerHTML = "";
    event.preventDefault();

    // Deactivate all toggle buttons
    document.querySelectorAll('.toggle-button.active').forEach(activeButton => {
        activeButton.classList.remove('active');
        activeButton.classList.add('disable');
    });

    const toggleArrow = this.parentElement.nextElementSibling;
    if (toggleArrow && toggleArrow.classList.contains('toggle-button')) {
        toggleArrow.classList.remove('disable');
        toggleArrow.classList.add('active');
    }

    // Remove styles and disable from previous button
    if (activeTrackOrderButton && activeTrackOrderButton !== this) {
        activeTrackOrderButton.style.opacity = '';
        activeTrackOrderButton.style.pointerEvents = '';
        activeTrackOrderButton.disabled = false;
    }
    activeTrackOrderButton = this;

    // Hide and clear previous tracking info
    document.querySelectorAll('.order-tracking-info.active').forEach(el => {
        el.classList.remove('active');
        el.classList.add('disable');
        el.innerHTML = ''; // Clear previous data
    });
    // Disable the current button and set it as active
    this.disabled = true;
    this.style.opacity = '0.6';
    this.style.pointerEvents = 'none';


    const orderName = this.getAttribute('data-order-name');
    const orderId = this.getAttribute('data-order-id');
    if (!orderId) {
        console.error('Order ID is missing or null. Ensure the data-order-name attribute is set correctly on the button:', this);
        return;
    }

    const email = document.getElementById('customer-info')?.dataset.email;
    const emailComponent = encodeURIComponent(email);
    const trackingHash = this.getAttribute('data-tracking-hash');


    // Show spinner inside the button and disable it
    submitButton.innerHTML = '<span class="spinner" style="position: relative; bottom: 2px; display: inline-block; width: 16px; height: 16px; border: 2px solid #f3f3f3; border-top: 2px solid #015F02; border-radius: 50%; animation: spin 0.8s linear infinite; vertical-align: middle; margin-right: 8px;"></span>' + '';
    submitButton.disabled = true;
    submitButton.style.opacity = '0.6';
    submitButton.style.pointerEvents = 'none';

    // New API call to fetch data from the provided URL
    const apiUrl = `https://api.restaurantware.com/app/rw/v1/order/main_us/orders/${orderName}`;

    try {
        const apiResponse = await fetch(apiUrl, {
        method: 'GET',
        headers: { 'Accept': 'application/json' }
        });

        if (!apiResponse.ok) {
        if (orderTrackingInfo && orderTrackingInfo.classList.contains('order-tracking-info')) {
            orderTrackingInfo.classList.remove('disable');
            orderTrackingInfo.classList.add('active');
            orderTrackingInfo.innerHTML = `<p style="color: red;">No tracking data is available at the moment. Please check back later or verify your details.</p>`;
        } else {
            console.error('Order tracking info container not found for the clicked button.');
        }
        console.error(`API Error ${apiResponse.status}:`, await apiResponse.text());
        return;
        }

        const apiData = await apiResponse.json();
        // Extract and print shipment tracking numbers
        const shipments = apiData.data[Object.keys(apiData.data)[0]].shipments;
        const orderID = apiData.data[Object.keys(apiData.data)[0]].ecomEntityId;
        // Append tracking numbers to the order-tracking-info div
        const trackingInfoDiv = document.querySelector('.order-tracking-info');
        shipments.forEach((shipment, index) => {
        if (!shipment.trackingNumber) {
            if (orderTrackingInfo && orderTrackingInfo.classList.contains('order-tracking-info')) {
                orderTrackingInfo.classList.remove('disable');
                orderTrackingInfo.classList.add('active');
                orderTrackingInfo.innerHTML = `<p style="color: red;">No tracking data is available at the moment. Please check back later or verify your details.</p>`;
            }
            return;
        }

        const trackingElementContainer = document.createElement('div');
        trackingElementContainer.classList.add('order-tracking-num-container');

        const trackingElement = document.createElement('div');
        trackingElement.classList.add('order-tracking-num'); // Add class to the tracking element

        const trackingHeader = document.createElement('div');
        trackingHeader.classList.add('order-tracking-header');

        const trackingDetailsHeader = document.createElement('div');
        trackingDetailsHeader.classList.add('order-tracking-details-header');

        const trackingDisplay = document.createElement('div');
        trackingDisplay.classList.add('order-tracking-num-info');

        trackingHeader.textContent = `TRACKING NUMBER: ${shipment.trackingNumber}`;
        // Add toggle arrow pointing downward at the end of the row
        const toggleArrow = document.createElement('span');
        toggleArrow.classList.add('toggle-arrow');
        toggleArrow.innerHTML = '<svg width="12" height="6" viewBox="0 0 12 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 6L0.803847 0.75L11.1962 0.750001L6 6Z" fill="#015F02"></path></svg>';
        
        // Auto-fetch tracking details immediately after showing tracking number
        (async () => {

            const detailsContainer = trackingElementContainer.querySelector('.tracking-details');
            if (detailsContainer && detailsContainer.style.display === 'block') {
        // Collapse the details if already open
        detailsContainer.style.display = 'none';
        toggleArrow.innerHTML = '<svg width="12" height="6" viewBox="0 0 12 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 6L0.803847 0.75L11.1962 0.750001L6 6Z" fill="#015F02"></path></svg>';
        return;
            }

            // Show spinner element
            let spinner = trackingDetailsHeader.querySelector('.spinner');
            
            if (!spinner) {
                spinner = document.createElement('div');
                spinner.classList.add('spinner');
                spinner.textContent = ' ';
                if (index === 0) {
                 trackingDetailsHeader.appendChild(spinner);
                }
            }

            spinner.style.display = 'block';

            if (!trackingHash) {
        console.error('Tracking hash is missing. Please check the data-tracking-hash attribute.');
        return;
            }
            const apiUrl = `https://api.restaurantware.com/app/rw/v1/order/main_us/orders/${orderID}/tracking/${shipment.trackingNumber}?email=${emailComponent}&key=${trackingHash}`;
            try {
        const response = await fetch(apiUrl);
        if (!response.ok) {
        const errorMessage = `Something went wrong! Please contact support team.`;
        const errorDiv = document.createElement('div');
        errorDiv.classList.add('error-message');
        errorDiv.style.color = 'red';
        errorDiv.textContent = errorMessage;

        // Append the error message to the trackingDetailsHeader
            trackingDetailsHeader.innerHTML = '';
            trackingDetailsHeader.appendChild(errorDiv);

        throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();
        const allTrackingResults = data.data.completeTrackResults[0].trackResults;

        const formattedResults = allTrackingResults.map(result => {
        const latestStatus = result.latestStatusDetail?.statusByLocale || "Unknown";
        // prefer derivedCode, fall back to code
        const latestDerivedStatus = result.latestStatusDetail?.derivedCode ?? result.latestStatusDetail?.code;
        const deliveryDate = result.dateAndTimes?.find(dt => dt.type === "ACTUAL_DELIVERY" || dt.type === "ESTIMATED_DELIVERY")?.dateTime || "N/A";
        const scanEvents = result.scanEvents || [];

        // don't mutate original array
        const sortedScanEvents = [...scanEvents].sort((a, b) => new Date(a.date) - new Date(b.date));
        const exceptionIndex = sortedScanEvents.findIndex(
            event => event.eventType === "DE" || event.eventType === "SE"
        );
        // Find index for 'Delivery updated' (eventType 'AR' and derivedStatusCode 'DF')
        const deliveryUpdatedIndex = sortedScanEvents.findIndex(
            event => event.eventType === "AR" && (event.derivedStatusCode === "DF" || event.derivedStatus === "Delivery updated")
        );
        let checkedEventDate = null;
        let hasException = false;
        if (exceptionIndex !== -1) {
            hasException = true;
            const beforeException = exceptionIndex > 0 ? sortedScanEvents[exceptionIndex - 1] : null;
            if (beforeException) {
                checkedEventDate = beforeException.date;
            }
        }

        // Delivery updated logic - check if latest status is "Delivery updated"
        let hasDeliveryUpdated = false;
        let checkedDeliveryUpdatedDate = null;
        
        // Check if the latest status is "Delivery updated" from latestStatusDetail
        const isLatestDeliveryUpdated = result.latestStatusDetail?.statusByLocale === "Delivery updated" || 
                                       result.latestStatusDetail?.derivedCode === "DF";
        
        if (isLatestDeliveryUpdated) {
            hasDeliveryUpdated = true;
            // For delivery updated status, we want to show it at the step before the current issue
            // Find the event before the most recent exception or use the second-to-last event
            if (sortedScanEvents.length > 1) {
                // If the latest event is an exception, use the event before it
                const latestEvent = sortedScanEvents[sortedScanEvents.length - 1];
                if (latestEvent.eventType === "SE" || latestEvent.eventType === "DE") {
                    checkedDeliveryUpdatedDate = sortedScanEvents[sortedScanEvents.length - 2].date;
                } else {
                    checkedDeliveryUpdatedDate = latestEvent.date;
                }
            } else if (sortedScanEvents.length === 1) {
                checkedDeliveryUpdatedDate = sortedScanEvents[0].date;
            }
        } else if (deliveryUpdatedIndex !== -1) {
            hasDeliveryUpdated = true;
            const beforeDeliveryUpdated = deliveryUpdatedIndex > 0 ? sortedScanEvents[deliveryUpdatedIndex - 1] : null;
            if (beforeDeliveryUpdated) {
                checkedDeliveryUpdatedDate = beforeDeliveryUpdated.date;
            }
        }

        // Only show Delivery exception if latestStatusDetail code or derivedCode is 'DE'
    const isLatestStatusDeliveryException = (result.latestStatusDetail?.code === 'DE' || result.latestStatusDetail?.derivedCode === 'DE');
    // Delivery updated status (code 'AR' and derivedCode 'DF')
    const isLatestStatusDeliveryUpdate = (result.latestStatusDetail?.derivedCode === 'DF' || result.latestStatusDetail?.statusByLocale === 'Delivery updated');

        // NOTE: adjust mappings as you prefer — OUT FOR DELIVERY is usually eventType "OD"
        const timelineSteps = [
            { label: "FROM", key: ["OC"] },
            { label: "WE HAVE YOUR PACKAGE", key: ["PU"] },
            { label: "ON THE WAY", key: ["DP","AO", "OW", "AR",] },       // AR/AO -> arrived/arriving, IT -> in-transit
            { label: "OUT FOR DELIVERY", key: ["OD"] },             // AR = Arrived / Out for delivery
            { label: "TO", key: ["DL"] }                        // DL = Delivered
        ];
        // Precompute which steps have a matching event (and keep the matching event)
        const stepMatches = timelineSteps.map(step => {
            const keys = Array.isArray(step.key) ? step.key : [step.key];
                const matchingEvents = sortedScanEvents.filter(event => { 
                // exact eventType match
                if (keys.includes(event.eventType)) return true;
                // derived status code from event (some feeds include derivedStatusCode)
                if (event.derivedStatusCode && keys.includes(event.derivedStatusCode)) return true;
                // derivedStatus text fallback (e.g., "In transit", "Out for delivery")
                if (event.derivedStatus && keys.some(k => event.derivedStatus.toLowerCase().includes(k.toLowerCase()))) return true;
                return false;
            });

            // Select the most recent event (latest date) from matching events
            const mostRecentEvent = matchingEvents.reduce((latest, current) => {
                const latestDate = new Date(latest?.date || 0);
                const currentDate = new Date(current.date);
                return currentDate > latestDate ? current : latest;
            }, null);

            return { matchingEvent: mostRecentEvent, isCompleted: !!mostRecentEvent };
        });
        // Determine which step should be considered "fulfilled":
        let fulfilledIndex = -1;
        
        // For delivery updated status, we need to find the highest completed step based on actual events
        if (isLatestStatusDeliveryUpdate) {
            // Find the highest step that has a matching event
            for (let i = stepMatches.length - 1; i >= 0; i--) {
                if (stepMatches[i].isCompleted) {
                    fulfilledIndex = i;
                    break;
                }
            }
        } else if (isLatestStatusDeliveryException) {
            // Find the step that matches 'DE'
            fulfilledIndex = timelineSteps.findIndex(step => {
                const keys = Array.isArray(step.key) ? step.key : [step.key];
                return keys.includes('DE');
            });
        } else if (latestDerivedStatus) {
            const idxByLatest = timelineSteps.findIndex(step => {
                const keys = Array.isArray(step.key) ? step.key : [step.key];
                return keys.includes(latestDerivedStatus);
            });
            if (idxByLatest !== -1) {
                fulfilledIndex = idxByLatest;
            }
        }

        // Update the timeline rendering logic
const timeline = timelineSteps.map((step, index) => {
    const match = stepMatches[index].matchingEvent;
    const isCompleted = index <= fulfilledIndex;
    const location = result.shipperInformation?.address || " ";
    const toLocation = result.recipientInformation?.address || " ";
    const currentLocation = result.latestStatusDetail?.scanLocation || " ";

    let className = `${isCompleted ? 'fulfilled' : ''}`.trim();
    let checkedLimit = fulfilledIndex;
    // If there is an exception, try to map it to the last fulfilled step
    if (hasException && checkedEventDate) {
        checkedLimit = stepMatches.reduce((acc, m, i) => {
            if (m.matchingEvent && new Date(m.matchingEvent.date) <= new Date(checkedEventDate)) {
                return i;
            }
            return acc;
        }, -1);
        if (checkedLimit === -1) checkedLimit = fulfilledIndex;
    }
    // If there is a delivery update, try to map it to the last fulfilled step
    let checkedDeliveryLimit = fulfilledIndex;
    if (hasDeliveryUpdated) {
        if (checkedDeliveryUpdatedDate) {
            // Find the latest step that has an event before or at the delivery updated date
            checkedDeliveryLimit = stepMatches.reduce((acc, m, i) => {
                if (m.matchingEvent && new Date(m.matchingEvent.date) <= new Date(checkedDeliveryUpdatedDate)) {
                    return i;
                }
                return acc;
            }, -1);
            if (checkedDeliveryLimit === -1) checkedDeliveryLimit = fulfilledIndex;
        } else {
            // If no specific date, use the current fulfilled index
            checkedDeliveryLimit = fulfilledIndex >= 0 ? fulfilledIndex : 0;
        }
    }
    const isDelivered = timelineSteps[fulfilledIndex]?.key?.includes('DL');
    // Delivery updated has priority over exception when both are present
    if ((isLatestStatusDeliveryUpdate || hasDeliveryUpdated) && checkedDeliveryLimit !== -1 && !isDelivered) {
        if (index < checkedDeliveryLimit) {
            className += ' delivery-updated-checked';
        } else if (index === checkedDeliveryLimit) {
            className += ' last-delivery-updated-checked';
        }
    } else if (isLatestStatusDeliveryException && checkedLimit !== -1 && !isDelivered) {
        // Exception highlight and label (only if not delivery updated)
        if (index < checkedLimit) {
            className += ' exeption-checked';
        } else if (index === checkedLimit) {
            className += ' last-exeption-checked';
        }
    }

    // Change label - delivery updated takes priority over exception
    let stepLabel = step.label;
    if ((isLatestStatusDeliveryUpdate || hasDeliveryUpdated) && checkedDeliveryLimit === index && !isDelivered) {
        stepLabel = 'Delivery updated';
    } else if (isLatestStatusDeliveryException && checkedLimit === index && !isDelivered) {
        stepLabel = 'Delivery exception';
    }

    return `
        <div class="timeline-step ${className}" data-step-index="${index}" data-completed="${isCompleted}">
            ${className.includes('last-exeption-checked') || className.includes('last-delivery-updated-checked') ? `<div class="timeline-warning-svg" style="position: absolute;z-index: 2;left: 2px;top: 2px; display:flex;justify-content:center;margin-bottom:2px;"><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="10" cy="10" r="10" fill="#FFD600"/><path d="M10 5V11" stroke="#333" stroke-width="2" stroke-linecap="round"/><circle cx="10" cy="14" r="1" fill="#333"/></svg></div>` : ''}
            <div class="timeline-circle"></div>
            <div class="timeline-line"></div>
            <div class="timeline-info">
                <div class="timeline-label">${stepLabel}</div>

                ${stepLabel === "FROM" ? `<div class="timeline-location">
                    <span>
                        ${location?.city ? `${location.city}, ` : ""}
                        ${location?.stateOrProvinceCode ? `<span class="upper">${location.stateOrProvinceCode}</span> ` : ""}
                        ${location?.countryCode ? `<span class="upper">${location.countryCode}</span>` : ""}
                    </span>
                </div>` : ''}

                ${stepLabel === "TO" ? `<div class="timeline-location">
                    <span>
                        ${toLocation?.city ? `${toLocation.city}, ` : ""}
                        ${toLocation?.stateOrProvinceCode ? `<span class="upper">${toLocation.stateOrProvinceCode}</span> ` : ""}
                        ${toLocation?.countryCode ? `<span class="upper">${toLocation.countryCode}</span>` : ""}
                    </span>
                </div>` : ''}

                ${stepLabel !== "FROM" && stepLabel !== "TO" && match && step.key.includes(latestDerivedStatus)
                    ? `<div class="timeline-location">
                        <span>
                            ${currentLocation.city ? `${currentLocation.city}, ` : ""}
                            ${currentLocation.stateOrProvinceCode ? `<span class="upper">${currentLocation.stateOrProvinceCode}</span> ` : ""}
                            ${currentLocation.countryCode ? `<span class="upper">${currentLocation.countryCode}</span>` : ""}
                        </span>
                    </div>`
                    : ''
                }

                ${stepLabel === "Delivery updated" && match
                    ? `<div class="timeline-location">
                        <span>
                            ${currentLocation.city ? `${currentLocation.city}, ` : ""}
                            ${currentLocation.stateOrProvinceCode ? `<span class="upper">${currentLocation.stateOrProvinceCode}</span> ` : ""}
                            ${currentLocation.countryCode ? `<span class="upper">${currentLocation.countryCode}</span>` : ""}
                        </span>
                    </div>`
                    : ''
                }

                ${match && step.key.includes(latestDerivedStatus)
                    ? `<div class="timeline-date">${formatDate(match.date)}</div>`
                    : ''
                }

                ${stepLabel === "Delivery updated" && match
                    ? `<div class="timeline-date">${formatDate(match.date)}</div>`
                    : ''
                }
            </div>
        </div>
    `;
}).join('');

        const trackingDetails = `
            <div class="tracking-table">
            <h3 style="margin-bottom: 10px; font-size: 1.6rem;">TRACKING DETAILS</h3>
            ${sortedScanEvents.length > 0
        ? sortedScanEvents.map(event => {
            return `
                <div class="tracking-event">
            <table class="tracking-event-table" style="table-layout: fixed; width: 100%; border-collapse: collapse; border: none !important; margin: 0; padding: 0;">
            <tr>
                <td>
                <span>${formatDate(event.date)}</span>

                    </span>
                    ${
                    event.scanLocation?.city
                        ? ` - <span>${event.scanLocation.city}, ${event.scanLocation.stateOrProvinceCode}</span>`
                        : ""
                    }
                </div>
                </td>
                <td>
                <div><span>${event.eventDescription}</span></div>
                </td>
            </tr>
            </table>
                </div>
            `;
            }).join('')
        : `<p style="color: red;">No tracking data is available at the moment. Please check back later or verify your details.</p>`
            }
            </div>
        `;
        return `
            <div class="tracking-details" style="padding: 10px; background-color: #ffffff; margin-top: 5px;">
            <div class="tracking-summary">
        <span>Status: <span class="tracking-summary-status">${latestStatus === "Unknown" ? " " : latestStatus}</span></span>
        <span>
            ${latestStatus.toLowerCase() === 'delivered' ? 'Delivered on:' : 'Expected delivery:'}
            <span class="tracking-summary-status">${formatDate(deliveryDate)}
            </span>
        </span>
            </div>

            <div class="timeline">${timeline}</div>
            <div class="timeline-table">${trackingDetails}</div>
            </div> `;
        }).join('');


        // Remove spinner
        spinner.style.display = 'none';

        // Append the response to the container
        const detailsDiv = document.createElement('div');
        detailsDiv.classList.add('tracking-details');
        detailsDiv.innerHTML = formattedResults;
        detailsDiv.style.display = index === 0 ? 'block' : 'none';

        // Disable toggle click for all but the first tracking number
        if (trackingElementContainer.querySelectorAll('.toggle-arrow').length > 1) {
            const toggleArrows = trackingElementContainer.querySelectorAll('.toggle-arrow');
            toggleArrows.forEach((arrow, index) => {
                if (index > 0) {
                    arrow.style.opacity = '0.4';
                    arrow.style.pointerEvents = 'none'; // prevent click
                }
            });
        }

        trackingDetailsHeader.innerHTML = '';
        trackingDetailsHeader.appendChild(detailsDiv);
        // Trigger fulfilled step animation after DOM updates
        setTimeout(() => {
        document.querySelectorAll('.timeline-step.fulfilled').forEach(step => {
            step.classList.add('animate');
        });
        }, 100);
        // Show the details
        detailsDiv.style.display = index === 0 ? 'block' : 'none';
        toggleArrow.addEventListener('click', () => {
        const isVisible = detailsDiv.style.display === 'block';
        detailsDiv.style.display = isVisible ? 'none' : 'block';
        toggleArrow.style.transform = isVisible ? 'rotate(0deg)' : 'rotate(180deg)';
        });
            } catch (error) {
        console.error('Error fetching tracking data:', error);
        spinner.style.display = 'none';
            }
        })();
        trackingElement.style.display = 'flex';
        trackingElement.style.flexDirection = 'column';
        trackingElement.appendChild(trackingHeader);
        trackingElement.appendChild(trackingDetailsHeader);
        trackingHeader.appendChild(toggleArrow);
        trackingElementContainer.appendChild(trackingElement);
        if (orderTrackingInfo && orderTrackingInfo.classList.contains('order-tracking-info')) {
            orderTrackingInfo.classList.remove('disable');
            orderTrackingInfo.classList.add('active');
            const toggleArrow = this.parentElement.nextElementSibling;
            if (toggleArrow && toggleArrow.classList.contains('toggle-button')) {
        toggleArrow.classList.remove('disable');
        toggleArrow.classList.add('active');
            }
            // orderTrackingInfo.innerHTML = "";
            orderTrackingInfo.appendChild(trackingElementContainer);
        } else {
            console.error('Order tracking info container not found for the clicked button.');
        }
        });
    } catch (error) {
        console.error("Error fetching tracking data:", error);
        if (!resultContainer) {
        console.error('Result container not found. Ensure the element with the correct class or ID exists in the DOM.');
        } else {
        resultContainer.style.display = 'block'; // Ensure the container is visible
        resultContainer.innerHTML = `<p style="color: red;">No tracking data is available at the moment. Please check back later or verify your details.</p>`;
        }
    } finally {
        submitButton.disabled = false;
        submitButton.textContent = "Track";
    }
    });
});

const toggleButtons = document.querySelectorAll('.toggle-button');

toggleButtons.forEach(button => {
    button.addEventListener('click', async () => {
    const trackingInfo = button.closest('.row').nextElementSibling;
    if (trackingInfo && trackingInfo.classList.contains('order-tracking-info')) {
    if (trackingInfo.classList.contains('active')) {
    trackingInfo.classList.remove('active');
    trackingInfo.classList.add('disable');
    button.style.transform = 'rotate(180deg)';
    } else {
    trackingInfo.classList.remove('disable');
    trackingInfo.classList.add('active');
    button.style.transform = 'rotate(0deg)';
    }
    }
    });
});

});

// HMAC generation is now handled in the Liquid template

function formatDate(dateInput) {
    if (!dateInput || dateInput === 'N/A') return 'N/A';

    try {
        // If it's a Date object, convert it to ISO string
        const dateString = dateInput instanceof Date ? dateInput.toISOString() : dateInput;

        // Split date and time
        const [date, timeWithOffset] = dateString.split('T');
        if (!timeWithOffset) return date;

        // Remove timezone part from time
        const time24 = timeWithOffset.split('-')[0].split('+')[0];
        const [hours, minutes] = time24.split(':');

        // Convert to 12-hour format
        const hours12 = ((+hours + 11) % 12) + 1;
        const ampm = +hours >= 12 ? 'PM' : 'AM';
        const time12 = `${hours12.toString().padStart(2, '0')}:${minutes} ${ampm}`;

        return `${date} ${time12}`;
    } catch (error) {
        console.warn('Date formatting failed:', error);
        return dateInput || 'N/A';
    }
}

